// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResults_root__2i9pH"};